import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PAYPAL_MOBILE_DEFAULT = createFcmDetails('paypal_mobile_default', {
	owner: 'Payments',
	context: 'Payment Forms',
	description: 'Sets Paypal as the default selected payment method for users on mobile',
	import: false,
});
